import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { getScriptFile } from './api';

export const projectFileKeys = {
  script: (projectId: string) => ['project-file', 'script', projectId] as const,
};

/** The script a project currently has, if any. */
export const useScriptFile = (projectId: string, enabled = true) =>
  useQuery({
    queryKey: projectFileKeys.script(projectId),
    queryFn: () => getScriptFile(supabase, projectId),
    enabled,
  });
